var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTmoLogoV2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 0.314453H0V35.3145H35V0.314453Z",
    fill: "#E20074"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.26953 21.8528V16.8047H9.89453H12.3176V21.8528H7.26953Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6836 21.8528V16.8047H25.5778H27.7317V21.8528H22.6836Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4618 5.36328H7.53876L7.26953 14.1806L8.61568 14.3825C8.88492 11.7575 9.55799 9.8729 10.6349 8.59405C11.7791 7.3152 13.3945 6.57482 15.4811 6.50751V24.8825C15.4811 26.4979 15.2791 27.5075 14.808 27.9787C14.4041 28.3825 13.7311 28.6517 12.7888 28.7191C12.5195 28.7191 12.0484 28.7864 11.3753 28.7864V30.1998H23.6926V28.7864C23.0195 28.7864 22.5484 28.7864 22.2791 28.7191C21.3368 28.6517 20.6638 28.3825 20.2599 27.9787C19.7888 27.5075 19.5868 26.4306 19.5868 24.8825V6.57482C21.6734 6.64213 23.2888 7.3152 24.433 8.66136C25.5772 9.9402 26.2503 11.8248 26.4522 14.4498L27.7984 14.2479L27.4618 5.36328Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTmoLogoV2);
export default __webpack_public_path__ + "static/media/tmo_logo_v2.28efa17b619550c6154288dd4cbfc5bd.svg";
export { ForwardRef as ReactComponent };